import React from 'react';
import founder from '../../images/founder.jpg';
import { Container, Grid, Typography, Box } from '@mui/material';
import { SecondaryButton } from '../Button';
import Infotip from '../Tooltip';
import { founderBody } from '../../content/about';

interface Props {
  expanded: boolean;
  onToggle: () => void;
}

const Founder = ({ expanded, onToggle }: Props) => {
  const paragraphs = expanded ? founderBody : [founderBody[0]];

  return (
    <Container sx={{ mt: 4, display: 'flex', justifyContent: 'center' }} maxWidth={false}>
      <Grid container id="founder" maxWidth='90%' alignItems='center' display='flex' justifyContent='center'>
        <Grid size={12}>
          <Box component="img" src={founder} alt='founder-image' data-testid="about-founder-image" sx={{ width: '100%', height: 'auto', borderRadius: '10%' }} />
        </Grid>
        <Grid size={12} pt={2} >
          <Grid size={12} display={'flex'} justifyContent={'center'} pb={2}>
            <Typography variant="h4" component="h2" data-testid="about-founder-title" gutterBottom sx={{ textAlign: 'center' }}>
              iet'ene ka{' '}
              <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
                mang
                <Infotip title="Meaning: Who founded iets'ene?"/>
              </Box>
            </Typography>
          </Grid>
          <Grid size={12} pb={2}>
            {paragraphs.map((text, i) => (
              <Typography key={i} variant='body1' fontSize={'1.4rem'} align='center' gutterBottom>
                {text}
              </Typography>
            ))}
          </Grid>
          <Grid size={12} display={'flex'} justifyContent={'center'}>
            <SecondaryButton
              sx={{ fontSize: { xs: '1rem', md: '1.8rem' } }}
              onClick={onToggle}
            >
              {expanded ? 'Show less' : 'Read more'}
            </SecondaryButton>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Founder;